export enum Meal {
    NONE = 'NONE',
    MEAT = 'MEAT',
    VEGETARIAN = 'VEGETARIAN'
}
